import { Component, OnInit, AfterViewInit, Input, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';

import { OkAloneService } from './ok-alone.service'
import { filter, map } from 'rxjs';

import { TranslocoService} from '@ngneat/transloco';

declare var require: any;

@Component({
  selector: 'ok-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = 'OK Alone Dashboard';

  widget:boolean = false;
  view:string = 'normal';

  @Input() token: any = "";
  @Input() menu: string = "";
  ul:any = "";
  cid:any="";
  ref:any = "";
  path:any = "";
  initial_path = '';

  

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    public okService:OkAloneService,
    private translocoService: TranslocoService,
    private elm: ElementRef
  ) {

    this.router.navigateByUrl('/loading');

    titleService.setTitle(this.title);


    iconSetService.icons = { ...iconSubset };


    this.token = this.elm.nativeElement.getAttribute('token');
    //console.log("token",this.token);

    this.menu = this.elm.nativeElement.getAttribute('menu');
    //console.log("menu",this.menu);

    //console.log(window.location);

    // Setup the intial path - ignore if it is / or one of those in the array
    
    if(!['/', '/loading','/login','/home'].includes(window.location.pathname)){
      this.initial_path = window.location.href.replace(window.location.origin,"");
      //this.initial_path = this.initial_path.split("?")[0];
      //console.log("initial_path",this.initial_path);
    }
    

    // See they have an auto login link
    let host_path=window.location.href;
    //console.log(host_path);
    
    let queryString = host_path.substring(host_path.indexOf("ul"));
    let urlParams = new URLSearchParams(queryString);
    if(urlParams.get('ul')){
      this.token = urlParams.get('ul');
      //console.log("token",this.token);
    }

    queryString = host_path.substring(host_path.indexOf("cid"));
    urlParams = new URLSearchParams(queryString);
    if(urlParams.get('cid')){
      this.cid = urlParams.get('cid');
      //console.log("cid",this.cid);
    }

    queryString = host_path.substring(host_path.indexOf("path"));
    urlParams = new URLSearchParams(queryString);
    if(urlParams.get('path')){
      this.path = urlParams.get('path');
      //console.log("path",this.path);
    }

    queryString = host_path.substring(host_path.indexOf("adp"));
    urlParams = new URLSearchParams(queryString);
    if(urlParams.get('adp')){
      //console.log("Is an ADP user");
      localStorage.setItem("is_adp", "true");
    }

    queryString = host_path.substring(host_path.indexOf("ref"));
    urlParams = new URLSearchParams(queryString);
    if(urlParams.get('ref')){
      this.ref = urlParams.get('ref');
      //console.log("ref",this.ref);
    }
    
    if(host_path.includes('from_admin')){
      //console.log("From Admin");
      localStorage.setItem("from_admin", "true");
      this.okService.from_admin = true;
    }

    if(this.menu){
      if(this.menu == "top"){
          this.okService.view.show_main_menu = false;
          this.okService.view.show_top_menu = true;
          this.okService.view.geotab = true;
          
          //console.log("Set to top menu")
      }
    }
    

    if(this.token){
      //console.log("Logout as new token");
      this.okService.logout();
    }
    if(this.ref){
      //console.log("Logout as have a ref");
      this.okService.logout();
    }

    this.okService.getLangChoice();

  }

  ngOnInit(): void {

    //console.log("ngOnInit start");


    // this.router.events.subscribe((evt) => {
    //   if (!(evt instanceof NavigationEnd)) {
    //     return;
    //   }
    // });


    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(title+' - '+this.title);
        }
      });

    //console.log("ngOnInit finish");


  }

  ngAfterViewInit(): void {
    //console.log("ngAfterViewInit");



        // Check if the user is logged in
        if(this.okService.isLoggedIn()){

        if(this.path && this.menu != "top"){
          //console.log("Logged in so go to path ",this.path);

          this.router.navigateByUrl(this.path);

        }else{
          //console.log("Logged in so go to home or initial path");

          if(this.initial_path){
            
            //console.log("Go to initial path ",this.initial_path);
            this.router.navigateByUrl(this.initial_path);
          }else{
            this.router.navigateByUrl('/home');
          }

          

        }


        }else{

          // Need to ignore if at resetpassword

          // See if we have a token to login with
          if(this.token){
            if(this.cid){
              this.okService.cid = this.cid;
              //console.log("Have a cid so login",this.okService.cid);
            }
            //console.log("Have a token so login");


            this.okService.post("auth/login",{token:this.token})
            .subscribe({
              next: (data) => {
                //console.log(data);
                this.okService.loginWorker(data.body);
              
                if(this.initial_path && this.menu != "top"){
                  //console.log("Go to",this.initial_path);
                  this.router.navigateByUrl(this.initial_path);
                }else{
                  //console.log("Go to Home");
                  this.router.navigateByUrl('/home');
                }

              },
              error: (e) => {
                //console.log("error","We could not log you in, please check your token");
                this.router.navigateByUrl('/login');
              },
              complete: () => {
                //console.info('complete');
              }
          });

          }else if(this.ref){
            
            
            this.okService.post("auth/login",{ref:this.ref})
            .subscribe({
              next: (data:any) => {
                //console.log(data);
                this.okService.loginWorker(data.body);
                if(data.body['alert']){
                  //console.log("Go to Alert");
                  let alertPath = '/reports/alert/'+data.body['alert'];
                  if (data.body['alert_action']) {
                    alertPath += '?action=' + encodeURIComponent(data.body['alert_action']);
                  }
                  this.router.navigateByUrl(alertPath);
                }else{
                  //console.log("Go to Home");
                  this.router.navigateByUrl('/home');
                }


              },
              error: (e) => {
                //console.log("error","We could not log you in, please check your token");
                this.router.navigateByUrl('/login');
              },
              complete: () => {
                //console.info('complete');
              }
          });
            
          }else{

            if(this.path && this.menu != "top"){
              //console.log("Has a path so go to path ",this.path);
              this.router.navigateByUrl(this.path);
    
            }else if(this.initial_path && this.menu != "top"){
              
              //console.log("Go to initial path ",this.initial_path);
              this.router.navigateByUrl(this.initial_path);

            }else{

              this.router.navigateByUrl('/login');
              
            }

          }


        }

  }
}
